import React, {useEffect, useRef, useState} from 'react';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

/**
 * @Description This function lets you return Details dialog component.
 * @Returns     Component
 * @Author      ibrahim AKIN
 */
function GalleryCarousel({images}) {
    const settings = {
        dots: false
    };
    window.onclick = function (event) {
        let modal = document.getElementById('myModal');
        if (event.target === modal) {
            modal.style.display = 'none';
        }
    };
    const [currentImg, setCurrentImg] = useState();
    const isScrolling = useRef(false);
    const slideIndex = useRef(0);
    const handleClick = (tile, tileI) => {
        if (!isScrolling.current) {
            let modal = document.getElementById('myModal');
            modal.style.display = 'block';
            slideIndex.current = tileI;
            setCurrentImg(tile);
        }
    }

    function showSlides(n) {
        if (n >= images.length) {
            slideIndex.current = 0;
        } else if (n < 0) {
            slideIndex.current = images.length - 1;
        } else {
            slideIndex.current = n;
        }
        setCurrentImg(images[slideIndex.current]);
    }

    function plusSlides(n) {
        showSlides(slideIndex.current + n);
    }

    return (
        <div>
            <div className="carousel-container">
                <Slider {...settings}>
                    {images?.map((tile, tileI) => (
                        <div key={tileI} className="column">
                            <img src={tile.thumbnail} alt="autommate" style={{width: '100%', cursor: 'pointer'}}
                                 draggable={false} onClick={() => {
                                handleClick(tile, tileI);
                            }}
                            />
                        </div>
                    ))}
                </Slider>
            </div>
            <div id="myModal" className="modal">
                <span className="close" onClick={function () {
                    let modal = document.getElementById("myModal");
                    modal.style.display = "none";
                }}>&times;</span>
                <img className="modal-content" id="img01" src={currentImg?.original} alt="autommate"/>
                <div id="caption">{currentImg?.title}</div>
                <a className="prev" onClick={() => {
                    plusSlides(-1)
                }}>&#10094;</a>
                <a className="next" onClick={() => {
                    plusSlides(1)
                }}>&#10095;</a>
            </div>
        </div>
    );
}

export default GalleryCarousel;
